import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  script!: any;
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      this.script = document.createElement('script');
    }
  }

  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY

      if (isPlatformBrowser(this.platformId)) {
        const head = document.getElementsByTagName('body')[0];
        if (!document.getElementById('testScriptName')) {
          this.script.type = 'text/javascript';
          this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
          this.script.id = 'newTestScriptName';
          this.script.async = true;
          head.appendChild(this.script);
        }
      }
    }, 100);
  }
}
